<template>
  <MainLayout>

    <!-- Header Moderno -->
    <PageHeader icon="ri-calendar-line" title="Nueva Programación" :subtitle="headerSubtitle" button-text="Actualizar"
      button-icon="ri-loop-right-line" @action="actualizarDisponibilidad" />

    <div class="content-container">
      <!-- Card Principal de Información -->
      <div class="info-card" v-if="cursoActual">
        <div class="info-header-actions">
          <h3 class="info-title">Información de tu Curso</h3>
        </div>
        <div class="info-section">
          <div class="info-row">
            <span class="info-label">
              <i class="ri-book-2-line"></i>
              Módulo:
            </span>
            <span class="info-value">{{ cursoActual.nivel ? cursoActual.nivel.descripcion : cursoActual.nombre }}</span>
          </div>

          <div class="info-row" v-if="siguienteTema">
            <span class="info-label">
              <i class="ri-checkbox-circle-line"></i>
              Tema:
            </span>
            <span class="info-value">{{ siguienteTema.nombre }}</span>
            <button v-if="puedeVerNotificacionTema" @click="mostrarNotificacionTema()" class="btn-notification">
              <i class="ri-information-line"></i>
            </button>
          </div>

          <div class="info-row" v-if="siguienteTema && siguienteTema.tipoObj">
            <span class="info-label">
              <i class="ri-building-line"></i>
              Salón:
            </span>
            <span class="info-value">{{ siguienteTema.tipoObj.nombre_largo }}</span>
          </div>

          <div class="info-row" v-if="sedes.length > 0 && sedeActual">
            <span class="info-label">
              <i class="ri-map-pin-line"></i>
              Sede:
            </span>
            <span class="info-value info-value-location">{{ sedeActual.nombre }}</span>
            <button class="btn-change" v-if="puedeCambiarSede && cambiandoTema == false" @click="cambiandoTema = true">
              Cambiar
            </button>
          </div>
        </div>

        <!-- Selector de Día -->
        <div v-if="dias && dias.length > 0" class="asw-form-group">
          <label class="asw-form-label">
            <i class="ri-calendar-2-line"></i>
            Selecciona el día:
          </label>
          <select v-model="dia" class="asw-select">
            <option disabled :value="null">Selecciona un día</option>
            <option v-for="(dia, index) in dias" :key="index" :value="dia">{{ dia.texto }}</option>
          </select>
        </div>

        <!-- Horarios Disponibles -->
        <div v-if="posibles_horas && posibles_horas.length > 0" class="horarios-section">
          <h3 class="section-title">Horarios Disponibles</h3>
          <div class="horarios-grid">
            <div v-for="(posible_hora, index) in posibles_horas" :key="index" class="horario-card">
              <div class="horario-time">
                <i class="ri-time-line"></i>
                {{ showHourLocal(posible_hora) }}
              </div>
              <button v-if="posible_hora.disponible > 0" class="btn-programar" @click="seleccionarHora(posible_hora)">
                <i class="ri-checkbox-circle-line"></i>
                Programar
              </button>
              <div v-else-if="posible_hora.mensaje_cierre" class="horario-closed">
                <span class="closed-label">Franja cerrada</span>
                <span class="closed-reason">{{ posible_hora.mensaje_cierre }}</span>
              </div>
              <button v-else class="btn-options" @click="consultarMasOpciones(posible_hora)">
                Más Opciones
              </button>
            </div>
          </div>
        </div>

        <!-- Nota sobre zona horaria -->
        <div class="timezone-note">

          <span><i class="ri-information-line mr-2"></i><strong>Nota aclaratoria:</strong> Las franjas horarias de la
            programación de clases se muestran de
            acuerdo a tu zona horaria local.</span>
        </div>

        <router-link :to="{ name: 'mis_clases' }" class="btn-mis-clases">
          Ver Mis Clases
        </router-link>

        <!-- Mensaje de Éxito/Error -->
        <div v-if="mensaje" class="alert-success-modern" v-html="mensaje"></div>
      </div>

      <!-- Enlaces de Acción -->
       <AccionesEstudiante/>

      <!-- Instrucciones -->
      <div class="instructions-section">
        <div class="instructions-header">
          <i class="ri-question-line"></i>
          <h3>Instrucciones para programar tus clases</h3>
        </div>

        <p class="instructions-intro">
          Recuerda que puedes programar tus clases hasta una hora antes del inicio de cada bloque.
          Lee con atención las siguientes indicaciones para aprovechar al máximo el sistema de programación:
        </p>

        <div class="instructions-grid">

          <div class="instruction-card">
            <div class="instruction-header" @click="toggleCard('programacion')">
              <div class="instruction-icon">
                <i class="ri-calendar-check-line"></i>
              </div>
              <h4>Programación de clases</h4>
              <button class="btn-card-collapse" :class="{ expanded: instructionCards.programacion }">
                <i class="ri-arrow-down-s-line"></i>
              </button>
            </div>
            <transition name="collapse">
              <div v-show="instructionCards.programacion" class="instruction-content">
                <ul>
                  <li>La programación se bloquea todos los días a las {{ minDate }} y se habilita nuevamente a las
                    {{ maxDate }}, abriendo los cupos del día siguiente.
                  </li>
                  <li>Si el sistema detecta que no hay cupos disponibles en un bloque, habilitará automáticamente el
                    siguiente día hábil para que puedas programar. Botón “Más opciones”.</li>
                  <li>Puedes tener hasta 5 clases programadas por día.</li>
                  <li>El sistema te mostrará disponibilidad después de cada nueva programación realizada.</li>
                </ul>
              </div>
            </transition>
          </div>

          <div class="instruction-card">
            <div class="instruction-header" @click="toggleCard('cancelaciones')">
              <div class="instruction-icon danger">
                <i class="ri-close-circle-line"></i>
              </div>
              <h4>Cancelaciones</h4>
              <button class="btn-card-collapse" :class="{ expanded: instructionCards.cancelaciones }">
                <i class="ri-arrow-down-s-line"></i>
              </button>
            </div>
            <transition name="collapse">
              <div v-show="instructionCards.cancelaciones" class="instruction-content">
                <ul>
                  <li>Las clases se pueden cancelar con mínimo 24 horas de anticipación.</li>
                  <li>Cuando cancelas a tiempo, tu cupo se libera automáticamente para que otro estudiante pueda
                    tomarlo.</li>
                  <li>Si no cancelas y no asistes, el sistema registrará la clase como vista pero no asistida.</li>
                </ul>
              </div>
            </transition>
          </div>

          <div class="instruction-card">
            <div class="instruction-header" @click="toggleCard('recomendaciones')">
              <div class="instruction-icon success">
                <i class="ri-checkbox-circle-line"></i>
              </div>
              <h4>Recomendaciones</h4>
              <button class="btn-card-collapse" :class="{ expanded: instructionCards.recomendaciones }">
                <i class="ri-arrow-down-s-line"></i>
              </button>
            </div>
            <transition name="collapse">
              <div v-show="instructionCards.recomendaciones" class="instruction-content">
                <ul>
                  <li>La rigurosidad en tu asistencia y programación será clave para tu avance y éxito en el
                    aprendizaje del inglés.</li>
                  <li>Recuerda revisar constantemente la disponibilidad, ya que los cupos se actualizan en tiempo real
                    según las cancelaciones de otros estudiantes.</li>
                </ul>
              </div>
            </transition>
          </div>

          <div class="instruction-card">
            <div class="instruction-header" @click="toggleCard('noAsistidas')">
              <div class="instruction-icon warning">
                <i class="ri-error-warning-line"></i>
              </div>
              <h4>Clases no asistidas</h4>
              <button class="btn-card-collapse" :class="{ expanded: instructionCards.noAsistidas }">
                <i class="ri-arrow-down-s-line"></i>
              </button>
            </div>
            <transition name="collapse">
              <div v-show="instructionCards.noAsistidas" class="instruction-content">
                <ul>
                  <li>Si no cancelas y no asistes, no podrás retomar esa clase desde el programador.</li>
                  <li>Si deseas reprogramar una clase no vista, puedes hacerlo a través del servicio de supletorios en
                    el
                    perfil “Estudiantes” de la página web de ASW.</li>
                </ul>
              </div>
            </transition>
          </div>

        </div>
      </div>
    </div>

    <!-- Modal de confirmación de programación -->
    <b-modal no-close-on-backdrop hide-header-close ok-title="Programar" @ok="reservar" @cancel="cancelarConfirmacion"
      @hide="cancelarConfirmacion" :title="tituloProgramacion" v-model="confirmando" id="modalConfirmacion"
      modal-class="modal-modern" centered>
      <template #modal-title>
        <div class="modal-title-modern">
          <span v-html="tituloProgramacion"></span>
        </div>
      </template>

      <div v-if="agendable" class="modal-content-modern">
        <div class="confirmation-card">
          <div class="confirmation-header">
            <div class="confirmation-icon">
              <i class="ri-checkbox-circle-line"></i>
            </div>
            <h4 class="confirmation-title">Confirma tu programación</h4>
          </div>


          <div class="confirmation-details">
            <div class="detail-row">

              <div class="detail-content">
                <span class="detail-label"><i class="ri-book-2-line"></i> Clase:</span>
                <span class="detail-value">{{ siguienteTema.nombre }}</span>
              </div>
            </div>

            <div class="detail-row">

              <div class="detail-content">
                <span class="detail-label"><i class="ri-calendar-2-line"></i>Día:</span>
                <span class="detail-value">{{ dia.texto }}</span>
              </div>
            </div>

            <div class="detail-row">

              <div class="detail-content">
                <span class="detail-label"><i class="ri-time-line"></i>Hora:</span>
                <span class="detail-value">{{ showHourLocal(horarioSeleccionado) }}</span>
              </div>
            </div>

            <div class="detail-row">

              <div class="detail-content">
                <span class="detail-label"><i class="ri-map-pin-line"></i>Sede:</span>
                <span class="detail-value">{{ sedeActual.nombre }}</span>
              </div>
            </div>
          </div>

          <div v-if="horarioSeleccionado.politica_cancel" class="policy-notice">
            <i class="ri-information-line"></i>
            <span>{{ horarioSeleccionado.politica_cancel }}</span>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal no-close-on-backdrop hide-header-close ok-only ok-title="Omitir" v-model="mostrandoNotificacionTema"
      id="modalNotificacionTema" :title="tituloNotificacionTema">
      <p>
        {{ textoNotificacionTema }}
      </p>
      <br>
      <p class="text-center">
        <b-link v-if="enlaceNotificacionTema" :href="enlaceNotificacionTema" target="_blank">Más información</b-link>
      </p>
    </b-modal>


    <b-modal @ok="procesarAceptarTerminos" @cancel="procesarDenegarTerminos" @hide="procesarDenegarTerminos"
      no-close-on-backdrop ok-title="Acepto" cancel-title="No Acepto" v-model="mostrarTyC"
      id="modalTerminosycondiciones" title="Términos y Condiciones de Uso">
      <div v-if="terminos_y_condiciones">
        {{ terminos_y_condiciones }}
      </div>
    </b-modal>

    <b-modal @ok="procesarAceptarSegundaOpcion" @cancel="procesarCancelarSegundaOpcion"
      @hide="procesarCancelarSegundaOpcion" no-close-on-backdrop ok-title="Programar" cancel-title="No Acepto"
      v-model="mostrandoSegundaOpcion" id="modalSegundaOpcion" title="Cupos disponibles" modal-class="modal-modern">
      <template #modal-title>
        <div class="modal-title-modern">
          <i class="ri-time-line"></i>
          <span v-html="tituloProgramacion"></span>
        </div>
      </template>
      <div v-if="getHoraSegundaOpcion.disponible > 0" class="segunda-opcion-content">
        <div class="segunda-opcion-success">
          <div class="success-icon">
            <i class="ri-checkbox-circle-line"></i>
          </div>
          <p class="success-message">
            <strong>¡Encontramos disponibilidad!</strong><br>
            Puedes programar tu clase <strong>{{ segundaOpcion.tema.nombre }}</strong> el día
            <strong>{{ segundaOpcion.horarios.texto }}</strong> a las
            <strong>{{ getHoraSegundaOpcion.nombre_corto }}</strong>.
          </p>
          <p class="success-question">¿Deseas aceptar esta opción?</p>
        </div>
      </div>
      <div v-else class="no-options-container">
        <div class="no-options-icon">
          <i class="ri-close-circle-line"></i>
        </div>
        <h4 class="no-options-subtitle">Sin Opciones Adicionales</h4>
        <p class="no-options-text">
          No encontramos más opciones disponibles para este horario.
        </p>
      </div>
    </b-modal>

    <b-modal hide-header hide-footer v-model="mostrandoNoHaySegundaOpcion" id="modalNoHaySegundaOpcion"
      modal-class="modal-modern" centered>
      <div class="no-options-container">
        <div class="no-options-icon">
          <i class="ri-close-circle-line"></i>
        </div>
        <h3 class="no-options-title">Sin Disponibilidad</h3>
        <p class="no-options-message">
          No encontramos más opciones disponibles para este horario.
          Por favor, intenta con otro día u horario.
        </p>
        <button @click="mostrandoNoHaySegundaOpcion = false" class="btn-close-modern">
          Entendido
        </button>
      </div>
    </b-modal>

    <!-- Modal de cambio de sede -->
    <b-modal no-close-on-backdrop hide-header-close ok-title="Cambiar" cancel-title="Cancelar" @ok="procesarCambiarSede"
      @cancel="nuevaSede = null" @hide="nuevaSede = null" v-model="cambiandoTema" id="modalCambiarTema"
      modal-class="modal-sede-modern" centered>
      <template #modal-title>
        <div class="modal-title-modern">
          <i class="ri-map-pin-line"></i>
          <span>Cambiar Sede</span>
        </div>
      </template>

      <div v-if="sedes.length > 0" class="sede-selection-container">
        <div class="tipo-sede-section">
          <label class="section-label">
            <i class="ri-building-line"></i>
            Tipo de Sede:
          </label>

          <div class="radio-group-modern">
            <label class="radio-option-modern" :class="{ 'active': tipoSedeSelected === 'virtual' }">
              <input v-model="tipoSedeSelected" type="radio" name="tipoSede" value="virtual" />
              <div class="radio-content">
                <i class="ri-computer-line"></i>
                <span>Virtual</span>
              </div>
              <div class="radio-indicator"></div>
            </label>

            <label class="radio-option-modern" :class="{ 'active': tipoSedeSelected === 'presencial' }">
              <input v-model="tipoSedeSelected" type="radio" name="tipoSede" value="presencial" />
              <div class="radio-content">
                <i class="ri-home-4-line"></i>
                <span>Presencial</span>
              </div>
              <div class="radio-indicator"></div>
            </label>
          </div>
        </div>

        <div class="sede-select-section">
          <label class="section-label">
            <i class="ri-map-pin-line"></i>
            Selecciona la Sede:
          </label>
          <select v-model="nuevaSede" class="select-sede-modern">
            <option disabled :value="null">Selecciona una sede</option>
            <option v-for="opcion in sedesFiltradas" :value="opcion.id" :key="opcion.id">
              {{ opcion.nombre }}
            </option>
          </select>
        </div>
      </div>
    </b-modal>
  </MainLayout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import Vue from 'vue';
import MainLayout from '@/components/Layout/MainLayout.vue';
import PageHeader from '@/components/Layout/PageHeader.vue';
import AccionesEstudiante from '@/features/nivel/components/AccionesEstudiante.vue';


export default {
  name: 'ProgramarClasePage',
  components: {
    MainLayout,
    PageHeader,
    AccionesEstudiante
  },
  data() {
    return {
      solicitud: null,
      diaSeleccionado: null,
      horarioSeleccionado: null,
      error: null,
      mensaje: null,
      confirmando: false,
      mostrandoNotificacionTema: false,
      mostrandoTyC: false,
      segundaOpcion: null,
      tituloNotificacionTema: null,
      textoNotificacionTema: null,
      enlaceNotificacionTema: '#',
      mostrandoSegundaOpcion: false,
      mostrandoNoHaySegundaOpcion: false,
      cambiandoTema: false,
      nuevaSede: null,
      tipoSedeSelected: 'presencial',
      delay_query: false,
      blockMessageDelay: "En este momento estamos presentando demoras en la respuesta. Agradecemos su comprensión. ",
      instructionCards: {
        programacion: false,
        cancelaciones: false,
        noAsistidas: false,
        recomendaciones: false
      }

    }
  },

  mounted() {
    this.consultarOpciones();
    this.fetchClases().then(reponse => {
      if (!this.debe_aceptar_terminos && this.clasesPendientes.length == 0) {
        this.mostrarMensajeInstrucciones();
      } else {
        this.mostrarNotificacionTema();
      }
    })
    if (!this.sedes || (this.sedes && this.sedes.length == 0)) {
      this.fetchSedes()
    }
    this.actualizarDisponibilidad()
  },
  methods: {
    ...mapActions({
      fetchTipos: 'academico/fetchTipos',
      fetchCursoActual: 'academico/fetchCursoActual',
      fetchOpciones: 'academico/fetchOpciones',
      fetchHorarios: 'academico/fetchHorarios',
      fetchDisponibilidad: 'academico/fetchDisponibilidad',
      agendar: 'academico/agendar',
      fetchClases: 'academico/fetchClases',
      aceptarTerminos: 'academico/aceptarTerminos',
      fetchSedes: 'sedes/fetchLista',
      cambiarSede: 'sedes/cambiarSede',
      fetchSedeActual: 'academico/fetchSedeActual',
      fetchCursoFinalizado: 'academico/fetchCursoFinalizado',
      fetchCertificarNivel: 'academico/fetchCertificarNivel',
    }),
    ...mapMutations({
      setHorariosDisponibles: 'academico/setHorariosDisponibles',
      startProcessing: 'startProcessing',
      stopProcessing: 'stopProcessing',
      setWarning: 'setWarning',
      addMensaje: 'auth/addMensaje',
    }),
    seleccionarHora(value) {
      this.horarioSeleccionado = value
      this.confirmando = true
    },
    cancelarConfirmacion() {
      this.horarioSeleccionado = null
    },
    toggleCard(cardName) {
      this.instructionCards[cardName] = !this.instructionCards[cardName]
    },
    actualizarDisponibilidad() {
      this.reiniciar()
      this.verificarSede()
      setTimeout(() => {
        if ((this.dias && this.dias.length > 0) || this.curso_finalizado) {
          this.delay_query = false;
        } else {
          this.delay_query = true;
        }
      }, 4200)
      this.fetchDisponibilidad().then((result) => {
        this.delay_query = false;
        if (!this.tipos || (this.tipos && this.tipos.length == 0)) {
          this.fetchTipos()
        }
        if (!this.cursoActual) {
          this.fetchCursoActual()
        }
      }).catch((err) => {
        this.delay_query = false;
        if (err && err.data && err.data.error && ['No tienes más temas pendientes.', 'No tienes más temas pendientes. Recuerda presentar tu test Versant'].includes(err.data.error)) {
          // Activar cambio de nivel
        }
      })
    },
    actualizarHorarios() {
      this.fetchHorarios()
    },
    consultarOpciones() {
      this.fetchOpciones().then(response => {
        let opcion = response.find(x => x.predeterminada);
        if (opcion) {
          this.opcion_clase = opcion.value;
        }
      });
    },
    reservar() {
      let tipo_solicitud = 'normal'
      let tipo_clase = 'regular'

      if (this.solicitud == 'normal') {
        tipo_solicitud = 'normal'
        tipo_clase = 'regular'
      } else if (this.solicitud == 'lab') {
        tipo_solicitud = 'asistente'
        tipo_clase = 'lab'
      } else if (this.solicitud == 'tutoria') {
        tipo_solicitud = 'tutoria'
        tipo_clase = 'regular'
      }
      tipo_solicitud = 'normal'  //FORZAMOS A NORMAL POR QUE YA NO HAY OPCIONES
      this.agendar({
        zona_horaria: Intl.DateTimeFormat().resolvedOptions().timeZone,
        tema_id: null,
        hora: this.horarioSeleccionado.hora,
        dia: this.diaSeleccionado.fecha,
        tipo_clase: tipo_clase,
        tipo_solicitud: tipo_solicitud,
      }).then((apiResponse) => {
        if (apiResponse.error) {
          this.error = apiResponse.error
        } else {
          let texto = "Programación exitosa para " + this.showDateLocal(apiResponse.fecha + " " + apiResponse.hora) + ".<br>"
          if (apiResponse.mensaje) {
            this.mensaje = texto + ' <strong>' + apiResponse.mensaje + '</strong>'
          } else {
            this.mensaje = texto
          }

          // Emitir evento para recargar notificaciones
          this.$root.$emit('reload-notifications')
        }
      }).finally(() => {
        this.reiniciar()
        this.fetchClases()
        this.actualizarDisponibilidad()
      })
    },
    reiniciar() {
      this.diaSeleccionado = null
      this.horarioSeleccionado = null
      this.error = null
      this.setHorariosDisponibles(null)
    },
    procesarAceptarTerminos() {
      this.aceptarTerminos()
    },
    procesarDenegarTerminos() {
      if (this.debe_aceptar_terminos) {
        this.$router.push('/')
      }
    },
    consultarMasOpciones(posible_hora) {
      let payload = {
        tema_id: this.siguienteTema.id,
        fecha: this.diaSeleccionado.fecha,
        hora: posible_hora.hora,
      }
      this.startProcessing()
      Vue.http.post('ver_mas_opciones', payload).then(
        response => {
          this.segundaOpcion = response.data
          if (this.getHoraSegundaOpcion.disponible > 0) {
            this.mostrandoSegundaOpcion = true
          } else {
            this.mostrandoNoHaySegundaOpcion = true
            setTimeout(() => {
              this.mostrandoNoHaySegundaOpcion = false
              this.segundaOpcion = null
            }, 3000)
          }

        }
      ).catch(error => {

      }).finally(() => {
        this.stopProcessing()
      })
    },
    procesarAceptarSegundaOpcion() {

      this.agendar({

        tema_id: this.segundaOpcion.tema.id,
        hora: this.getHoraSegundaOpcion.hora,
        dia: this.segundaOpcion.horarios.fecha,
        tipo_clase: null,
        tipo_solicitud: 'normal',
        segunda_opcion: true
      }).then((apiResponse) => {
        if (apiResponse.error) {
          this.error = apiResponse.error
        } else {
          let texto = "Programación exitosa para " + this.showDateLocal(apiResponse.fecha + " " + apiResponse.hora) + "."
          if (apiResponse.mensaje) {
            this.mensaje = texto + ' ' + apiResponse.mensaje
          } else {
            this.mensaje = texto
          }

          // Emitir evento para recargar notificaciones
          this.$root.$emit('reload-notifications')
        }
      }).finally(() => {
        this.reiniciar()
        this.fetchClases()
        this.actualizarDisponibilidad()
      })
    },
    procesarCancelarSegundaOpcion() {
      this.mostrandoSegundaOpcion = false
      this.segundaOpcion = null
    },
    procesarCambiarSede() {
      this.cambiarSede({ sede_id: this.nuevaSede }).then((apiResponse) => {
        this.setWarning(apiResponse.mensaje)
      }).finally(() => {
        this.nuevaSede = null
        this.actualizarDisponibilidad()
        this.fetchSedeActual()
      })
    },
    mostrarNotificacionTema() {
      if (this.puedeVerNotificacionTema) {
        this.mostrandoNotificacionTema = true;
        this.textoNotificacionTema = this.siguienteTema.notificacion_texto
        this.enlaceNotificacionTema = this.siguienteTema.notificacion_enlace
        this.tituloNotificacionTema = this.siguienteTema.nombre;
      }
    },
    mostrarMensajeInstrucciones() {
      const instructionMessage = {
        variant: 'info',
        html: '<strong>📚 Información importante:</strong> El sistema mostrará la disponibilidad de horarios a partir del primer bloque programado.',
        autoDismiss: false,
      };

      setTimeout(() => {
        const messageExists = this.mensajes.some(mensaje =>
          mensaje.variant === instructionMessage.variant && mensaje.html === instructionMessage.html
        );

        if (!messageExists) {
          this.addMensaje(instructionMessage);
        }
      }, 500);
    },
    verificarSede() {
      if (this.esClase0) {
        if (this.sedeActual.id != 30) {
          this.nuevaSede = 30;
          this.procesarCambiarSede();
        }
      }
    },
    showHourLocal(posible_hora) {
      if (this.sedeActual && this.sedeActual.es_virtual === 1 && this.userTimeZone !== 'America/Bogota') {
        let marca_tiempo = posible_hora.marca_tiempo;
        let fecha = new Date(marca_tiempo + "-05:00");
        return this.maskHour(fecha)
      } else {
        return posible_hora.nombre_corto;
      }
      // return fecha.format('h:mm a')
    },
    showDateLocal(marca_tiempo) {
      if (this.sedeActual && this.sedeActual.es_virtual === 1 && this.userTimeZone !== 'America/Bogota') {
        let fecha = new Date(marca_tiempo + "-05:00");
        return fecha.toLocaleString()
      } else {
        return marca_tiempo;
      }
    },
    maskHour(fecha) {
      return `${fecha.getHours() > 12 ? fecha.getHours() - 12 : fecha.getHours()}:${(fecha.getMinutes()).toString().padStart(2, '0')} ${fecha.getHours() >= 12 ? 'PM' : 'AM'}`;
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      cursoActual: state => state.academico.cursoActual,
      siguienteTema: state => state.academico.siguienteTema,
      tipos: state => state.academico.tipos,
      dias: state => state.academico.horariosDisponibles,
      opciones: state => state.academico.opcionesDisponibles,
      ultima_actualizacion_horarios: state => state.academico.ultima_actualizacion_horarios,
      debe_aceptar_terminos: state => state.academico.debe_aceptar_terminos,
      terminos_y_condiciones: state => state.academico.terminos_y_condiciones,
      sedes: state => state.sedes.lista,
      sedeActual: state => state.academico.sedeActual,
      curso_finalizado: state => state.academico.curso_finalizado,
      mensajes: state => state.auth.mensajes,

    }),
    ...mapGetters({
      clasesPendientes: 'academico/clasesPendientes',
      getSede: 'sedes/getSede',
    }),

    mostrarTyC: {
      get() {
        return this.debe_aceptar_terminos || this.mostrandoTyC
      },
      set(value) {
        this.mostrandoTyC = value
      }
    },
    dia: {
      get() {
        return this.diaSeleccionado;
      },
      set(value) {
        this.diaSeleccionado = value;
      }
    },
    hora: {
      get() {
        return this.horarioSeleccionado;
      },
      set(value) {
        this.horarioSeleccionado = value;
      }
    },
    puedeCambiarSede() {
      if (this.esClase0) {
        return false;
      } else {
        return true;
      }
    },
    esClase0() {
      if (this.siguienteTema) {
        if (this.siguienteTema.tipo === 'clase_0') {
          return true;
        }
      }
      return false;
    },
    posibles_horas: {
      get() {
        if (this.diaSeleccionado) {
          return this.diaSeleccionado.horas;
        } else {
          return null
        }

      },
      set(value) {

      }
    },
    agendable: {
      get() {
        return (this.siguienteTema && this.dias && this.diaSeleccionado && this.horarioSeleccionado)
      },
      set(value) { }
    },
    lastTime() {
      if (this.ultima_actualizacion_horarios) {
        return this.ultima_actualizacion_horarios.toLocaleString() // 'es-CO', {timeZone:"America/Bogota"}
      }
      return null
    },
    zonaRegional() {
      const zonaVisible = this.userTimeZone === 'America/Bogota'
        ? 'América/Bogotá'
        : this.userTimeZone;
      return `(${zonaVisible})`;
    },
    getHoraSegundaOpcion() {
      if (this.segundaOpcion && this.segundaOpcion.horarios && this.segundaOpcion.horarios.horas && this.segundaOpcion.horarios.horas.length > 0) {
        return this.segundaOpcion.horarios.horas[0]
      }
      return false
    },
    sedesFiltradas() {
      return this.sedes.filter(element => {
        if (this.tipoSedeSelected == 'presencial') {
          return element.es_virtual == 0
        } else {
          return element.es_virtual == 1
        }

      })
    },
    puedeVerNotificacionTema() {
      if (this.siguienteTema && this.siguienteTema.notificacion_mostrar && this.siguienteTema.notificacion_texto) {
        return true;
      }
      return false;
    },
    tituloProgramacion() {
      if (this.sedeActual) {
        return `SEDE ${this.sedeActual ? this.sedeActual.nombre : ''} ${this.sedeActual.es_virtual ? "- VIRTUAL" : "- PRESENCIAL"}`;
      } else {
        return "No ha seleccionado sede";
      }
    },
    minDate() {
      if (this.opciones) {
        let filtro = this.opciones.find(x => x.value == 'clase')
        if (filtro) {
          return this.maskHour(new Date(filtro.min_date + "-05:00"))
        }
      }
      return "";
    },
    maxDate() {
      if (this.opciones) {
        let filtro = this.opciones.find(x => x.value == 'clase')
        if (filtro) {
          return this.maskHour(new Date(filtro.max_date + "-05:00"))
        }
      } else {
        return "";
      }
    },
    headerSubtitle() {
      if (this.lastTime) {
        return `Última actualización: ${this.lastTime} ${this.zonaRegional}`;
      }
      return '';
    },
    userTimeZone() {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

  }
}
</script>

<style src="../../assets/styles/shared-forms.css"></style>
<style src="../../assets/styles/shared-scheduling.css"></style>

<style scoped>
/* ============================================================================
   ESTILOS ESPECÍFICOS DE PROGRAMAR
   ============================================================================ */

/* Estilos específicos del contenedor cuando tiene más ancho */
.scheduling-container {
  max-width: 1200px;
}

/* Header con separador */
.info-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  padding-bottom: 0.25rem;
  border-bottom: 2px solid var(--theme-border-color);
}

.info-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
}

.info-row .info-value-location {
  flex: 0 1 auto;
}

.info-row .btn-change,
.info-row .btn-change:hover {
  padding: 0.375rem 0.75rem;
  background: transparent;
  border: 1px solid var(--app-primary-blue);
  border-radius: 8px;
  color: var(--app-primary-blue);
  box-shadow: none;
  transform: none;
}

.info-row .btn-change:hover {
  background: var(--theme-hover-bg-light);
}

.info-row .btn-change:focus-visible {
  outline: 2px solid var(--app-primary-blue);
  outline-offset: 3px;
}

html.dark-theme .info-row .btn-change,
html.dark-theme .info-row .btn-change:hover {
  color: var(--app-color-cyan-light);
  border-color: var(--app-color-cyan-light);
}

/* Botón de mis clases */
.btn-mis-clases {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.625rem 1rem;
  background: var(--theme-gradient-primary);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--theme-shadow-sm);
  margin: 1rem auto 0 auto;
  max-width: fit-content;
}

.btn-mis-clases:hover {
  transform: translateY(-2px);
  box-shadow: var(--theme-shadow-md);
  text-decoration: none;
  color: white;
}

/* Tamaños específicos de botones en Programar */
.btn-notification {
  width: 36px;
  height: 36px;
}

/* Tamaño de fuente específico para horario */
.horario-time {
  font-size: 15px;
}

.horario-card {
  padding: 0.4rem 1rem;
}

.btn-programar,
.btn-options {
  font-size: 0.9rem;
  padding: 0.4rem 1rem;
}

.closed-label {
  font-size: 0.85rem;
}

.closed-reason {
  font-size: 0.8rem;
}

/* Nota de zona horaria - específica de Programar */
.timezone-note {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0.5rem;
  background: rgba(13, 78, 140, 0.1);
  border-left: 3px solid var(--app-primary-blue);
  border-radius: 8px;
  margin-top: 1rem;
}

.timezone-note svg {
  color: var(--app-primary-blue);
  flex-shrink: 0;
  margin-top: 2px;
}

.timezone-note span {
  flex: 1;
  font-size: 0.9rem;
  color: var(--theme-text-secondary);
  line-height: 1.6;
}

/* Responsive específico de Programar */
@media (max-width: 768px) {
  .info-header-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
  }

  .btn-mis-clases {
    width: 100%;
    justify-content: center;
  }
}

/* ============================================================================
   MODAL SIN OPCIONES DISPONIBLES - ESTILO MODERNO
   ============================================================================ */

.no-options-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding: 1.5rem 1rem;
  text-align: center;
}

.no-options-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(255, 59, 48, 0.1) 0%, rgba(255, 107, 107, 0.1) 100%);
  border-radius: 50%;
  animation: pulse-error 2s ease-in-out infinite;
}

.no-options-icon svg {
  color: #ff3b30;
}

@keyframes pulse-error {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(255, 59, 48, 0.4);
  }

  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(255, 59, 48, 0);
  }
}

.no-options-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
}

.no-options-message {
  font-size: 1rem;
  color: var(--theme-text-secondary);
  line-height: 1.6;
  margin: 0;
  max-width: 400px;
}

.btn-close-modern {
  padding: 0.75rem 2rem;
  background: var(--theme-gradient-primary);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(13, 78, 140, 0.3);
  margin-top: 0.5rem;
}

.btn-close-modern:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(13, 78, 140, 0.4);
}

.btn-close-modern:active {
  transform: translateY(0);
}

/* ============================================================================
   MODAL SEGUNDA OPCIÓN - ESTILOS MODERNOS
   ============================================================================ */

.segunda-opcion-content {
  padding: 1rem 0;
}

.segunda-opcion-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(52, 199, 89, 0.1) 0%, rgba(48, 209, 88, 0.15) 100%);
  border-radius: 50%;
  animation: pulse-success 2s ease-in-out infinite;
}

.success-icon svg {
  color: #34c759;
}

@keyframes pulse-success {

  0%,
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(52, 199, 89, 0.4);
  }

  50% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(52, 199, 89, 0);
  }
}

.success-message {
  font-size: 1rem;
  color: var(--theme-text-secondary);
  line-height: 1.7;
  margin: 0;
}

.success-message strong {
  color: var(--theme-text-primary);
}

.success-question {
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--theme-text-primary);
  margin: 0.5rem 0 0 0;
}

.no-options-subtitle {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--theme-text-primary);
  margin: 0;
}

.no-options-text {
  font-size: 0.95rem;
  color: var(--theme-text-secondary);
  line-height: 1.5;
  margin: 0;
}
</style>

<style src="../../assets/styles/shared-modals.css"></style>
